<template>
  <ParagraphBody
    :bodySize="$options.bodySizes.tiny"
    :class="[$style.legalNotice]"
    data-test-id="legal-notice"
    hasMargin
  >
    {{ legalNotice }}
  </ParagraphBody>
</template>

<script>
import { Constants, ParagraphBody } from '@jumpcloud/ui-components';
import stripHtml from 'client/util/StripHtml';

const {
  typeStyles: {
    bodySizes,
  },
} = Constants;

export default {
  name: 'LegalNotice',

  bodySizes,

  components: {
    ParagraphBody,
  },

  data() {
    const year = new Date().getFullYear();

    return {
      legalNotice: stripHtml(
        `<p>&copy; JumpCloud Inc. All rights reserved. ${year}<br>Various trademarks held by their respective owners. JumpCloud has been issued the following patents for its products; Patent Nos.: 10,257,017; 10,644,930; 10,924,327; 9,641,530; 10,057,266; 10,630,685; 10,601,827; 11,171,957; 10,298,579; 11,159,527; 11,057,430; and 10,848,478.</p>`,
      ),
    };
  },

};
</script>

<style module scoped>
.legalNotice {
  padding: 1.5rem;
  white-space: pre-wrap;
}
</style>
